import React from 'react';

const STEPS = ['Property Structure', 'Amenities'];

const OnboardingStepper = ({ currentStep = 0 }) => (
  <div className="community-stepper">
    {STEPS.map((label, index) => (
      <div
        key={label}
        className={`community-stepper-item ${
          index === currentStep ? 'active' : index < currentStep ? 'completed' : ''
        }`}
      >
        <span className="community-stepper-dot">{index + 1}</span>
        <span className="community-stepper-label">{label}</span>
      </div>
    ))}
  </div>
);

export default OnboardingStepper;
